module.exports = __webpack_public_path__ + "static/img/ktp-sample.9f01737d.png";